export const PRICE_RANGE_OPTIONS = [
  { key: "1W", days: 7 },
  { key: "1M", days: 30 },
  { key: "3M", days: 90 },
  { key: "6M", days: 180 },
  { key: "1Y", days: 365 },
  { key: "ALL", days: null },
];

export function parseRecordedAtMs(value) {
  const ms = new Date(value).getTime();
  return Number.isFinite(ms) ? ms : null;
}

export function sortPriceHistoryChronological(series) {
  return [...(series || [])]
    .filter((row) => parseRecordedAtMs(row?.recorded_at) != null)
    .sort((a, b) => parseRecordedAtMs(a.recorded_at) - parseRecordedAtMs(b.recorded_at));
}

/**
 * Filter snapshots to the selected window ending at the latest recorded price
 * (not calendar "today"), so historical portfolios still respond to 1W/1M/etc.
 */
export function filterPriceHistoryByRange(series, rangeKey) {
  const sorted = sortPriceHistoryChronological(series);
  const opt = PRICE_RANGE_OPTIONS.find((r) => r.key === rangeKey);
  if (!opt || opt.days == null) return sorted;
  if (!sorted.length) return [];

  const latestMs = parseRecordedAtMs(sorted[sorted.length - 1].recorded_at);
  const cutoff = latestMs - opt.days * 86400000;
  return sorted.filter((row) => parseRecordedAtMs(row.recorded_at) >= cutoff);
}

export function priceHistoryRangeCaption(series, rangeKey) {
  const filtered = filterPriceHistoryByRange(series, rangeKey);
  if (!filtered.length) return null;
  const start = new Date(filtered[0].recorded_at).toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
  const end = new Date(filtered[filtered.length - 1].recorded_at).toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
  const n = filtered.length;
  return `${start} – ${end} · ${n} snapshot${n === 1 ? "" : "s"}`;
}
